import React from 'preact/compat';
import { createRoot } from 'preact/compat/client';
import Flyout from 'Flyout/components/Flyout';

export default function init() {
    function initializeFlyout() {
        const root = document.querySelectorAll('#navigation')[0];
        // only try to initialize, when we have the navigation present
        if (typeof root !== 'undefined') {
            createRoot(root).render(
                React.createElement(Flyout),
            );
        }
    }
    // the load event might have have been triggered already at this point.
    // check if we can initialize immediately
    if (document.readyState === 'complete') {
        initializeFlyout();
    } else {
        window.addEventListener('load', initializeFlyout);
    }

    // don't propagate clicks on targets that got already removed by react
    document.getElementById('navigation-panel')?.addEventListener('click', (e) => {
        if (!document.contains(e.target)) {
            e.stopPropagation();
        }
    });
}
